import { describeKnowledgeApiError } from 'utils/knowledgeErrors';
import { useState, useCallback, useRef } from 'react';
import { JustRightHeightModal } from 'components/styled/scoped';
import { message } from 'antd';
import { css } from '@emotion/css';
import { Formik } from 'formik';
import { usePresetTimeMutate } from '@knowledge/knowledges/general/edit/atom/presetTime';
import TimeRangeImpl from './TimeRangeImpl';
import { newPresetTime } from './helper';
import { useTranslate } from '@tolgee/react';

function useTimeRange() {
  const [visible, setVisible] = useState(false);
  const dataSourceRef = useRef<Knowledge.PresetTime>();
  const { t } = useTranslate();
  const open = useCallback((data?: Knowledge.PresetTime) => {
    dataSourceRef.current = data;
    setVisible(true);
  }, []);
  const close = useCallback(() => {
    setVisible(false);
  }, []);

  const isEdit = !!dataSourceRef.current?.id;
  const { createPT, editPT, loading } = usePresetTimeMutate();
  const modalInstance = visible && (
    <Formik
      initialValues={isEdit ? dataSourceRef.current! : newPresetTime()}
      onSubmit={async (values) => {
        try {
          if (values?.id) {
            await editPT(values);
          } else {
            await createPT(values);
          }
          message.success(t('operation.saveSucceed'));
          close();
        } catch (e) {
          message.error(describeKnowledgeApiError(e, undefined, t('operation.saveFailed')));
        }
      }}
    >
      {(formProps) => {
        const { handleSubmit, values } = formProps;
        return (
          <JustRightHeightModal
            visible={visible}
            onCancel={close}
            width={620}
            title={isEdit ? t('knowledge.编辑时间段') : t('knowledge.新增时间段')}
            centered
            destroyOnClose
            className={css`
              .ant-modal-body {
                margin: 0 !important;
                padding: 0;
              }
            `}
            okButtonProps={{
              loading,
            }}
            onOk={() => handleSubmit()}
            okText={t('phrase.保存')}
          >
            <TimeRangeImpl data={values} />
          </JustRightHeightModal>
        );
      }}
    </Formik>
  );

  return [open, modalInstance] as const;
}

export default useTimeRange;
